export enum SupportedLanguage {
  En = 'en',
  Es = 'es',
  Pt = 'pt',
}
